import React from 'react';

import { CarePlan } from '~clients/models';

import { CarePlanTab } from '~clients/config/carePlanTypes';

import AssessedNeedsTab from './assessed-needs/AssessedNeedsTab';
import CulturalSafetyTab from './cultural-safety/CulturalSafetyTab';
import GoalsTab from './goals/GoalsTab';
import OverviewTab from './overview/OverviewTab';
import CarePlanReviewsTab from './reviews/CarePlanReviewsTab';
import ServicesDeliveryTab from './service-lines/ServicesDeliveryTab';

// Panel registry mapping each care-plan tab to its full component. Selecting a plan
// mounts every visible tab (they stay mounted while hidden), so each receives isActive.

interface PanelProps {
  plan: CarePlan;
  /** Whether this tab is the currently-visible one (tabs stay mounted while hidden). */
  isActive?: boolean;
}

export const CARE_PLAN_TAB_PANELS: Record<CarePlanTab, React.FC<PanelProps>> = {
  overview: OverviewTab,
  needs: AssessedNeedsTab,
  goals: GoalsTab,
  service_lines: ServicesDeliveryTab,
  cultural_safety: CulturalSafetyTab,
  reviews: CarePlanReviewsTab,
};
